/* facts-dosing-levels.js · FACTS Dosier-Ebenen · v2 · 2026-09-02
 * ------------------------------------------------------------------
 * Setzt `is-js` (die Zeichen starten unsichtbar) und einmalig `is-in`,
 * sobald die Section den Ausloesepunkt im Fenster erreicht. Die Folge
 * der Bewegungen steht im CSS. Gerechnet wird im Scroll-Ereignis, nicht
 * in requestAnimationFrame (steht in verdeckten Tabs still) und nicht
 * in IntersectionObserver (liefert dort ebenfalls nichts).
 * Bei reduced-motion passiert nichts: alles steht sofort.
 */
(function () {
  'use strict';
  function init(root) {
    if (root._fdl) return;
    root._fdl = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var grid = root.querySelector('.fdl__grid');
    var items = [].slice.call(root.querySelectorAll('.fdl__item'));
    var buttons = [].slice.call(root.querySelectorAll('[data-fdl-play]'));
    if (!grid || !items.length) return;

    function play(item) {
      if (reduce || !item) return;
      item.classList.remove('is-playing');
      void item.offsetWidth;
      item.classList.add('is-playing');
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        play(button.closest('.fdl__item'));
      });
    });

    if (reduce) return;
    var trigger = parseInt(root.getAttribute('data-trigger'), 10);
    if (isNaN(trigger)) trigger = 80;
    trigger = trigger / 100;
    root.classList.add('is-js');
    function check() {
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.top < vh * trigger && r.bottom > 0) {
        root.classList.add('is-in');
        items.forEach(function (item) { item.classList.add('is-playing'); });
        window.removeEventListener('scroll', check);
        window.removeEventListener('resize', check);
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);

    var activeIndex = 0;
    var scrollTimer;
    function playNearest() {
      if (!window.matchMedia('(max-width: 699px)').matches) return;
      var gridBox = grid.getBoundingClientRect();
      var center = gridBox.left + gridBox.width / 2;
      var nearest = 0;
      var distance = Infinity;
      items.forEach(function (item, index) {
        var box = item.getBoundingClientRect();
        var nextDistance = Math.abs(box.left + box.width / 2 - center);
        if (nextDistance < distance) {
          distance = nextDistance;
          nearest = index;
        }
      });
      if (nearest !== activeIndex) {
        activeIndex = nearest;
        play(items[nearest]);
      }
    }
    grid.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(playNearest, 90);
    }, { passive: true });
    /* Ein Takt spaeter, damit der Startzustand (is-js) vor dem Ziel-
       zustand gemalt wird; Timer statt rAF, siehe oben. */
    setTimeout(check, 60);
  }
  function boot() {
    [].slice.call(document.querySelectorAll('[data-fdl]')).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
